export default __webpack_public_path__ + "static/media/https-lock.9028b516.svg";